import { ReactNode } from 'react';

export interface RadioItem<T = any> {
  title: string;
  subtitle?: string;
  value: T;
  leftView?: ReactNode;
  single: boolean;
  selected: boolean;
}

export const useRadio = () => {
  const onClick = (items: RadioItem<any>[], item: RadioItem, onChange: (items: RadioItem[]) => void) => {
    if (item.single) {
      items.forEach((i) => (i.selected = false));
    } else {
      // Unselect the single options
      items.forEach((i) => {
        if (i.single) {
          i.selected = false;
        }
      });
    }
    item.selected = item.single ? true : !item.selected;
    onChange(item.single ? [item] : items.filter((i) => i.selected));
  };

  return { onClick };
};
